define(
    'NMSDesignSystem.ContentPages.Shopping',
    [
        'SC.CCT.Html.View',
        'nms_request_a_quote_fallback.tpl'
    ],
    function NMSDesignSystemContentPagesShopping(SCCCTHtmlView, nmsRequestAQuoteFallbackTpl) {
        'use strict';

        var pilotClass = 'nms-content-page-pilot';
        var contentClass = 'nms-content-article';
        var breadcrumbClass = 'nms-content-breadcrumb';
        var duplicateClass = 'nms-content-duplicate-title';
        var supportedRoutes = {
            '/about-us': true,
            '/contact-us': true,
            '/shipping': true,
            '/returns': true,
            '/terms-conditions': true,
            '/privacy-policy': true,
            '/request-a-quote': true,
            '/pre-book': true
        };


        // Use the existing CDN presets; keep the CMS content and its layout intact.
        function responsiveContactHtml(html, imageSizes) {
            var wanted = { nmscard: 400, nmscard2x: 800, zoom: 1200, fullscreen: 2000 };
            var presets = {};
            var candidates = [];
            var names = ['nmscard', 'nmscard2x', 'zoom', 'fullscreen'];

            if (typeof html !== 'string' || !Array.isArray(imageSizes)) {
                return html;
            }
            imageSizes.forEach(function checkPreset(size) {
                var width = wanted[size && size.name];
                var id = size && String(size.internalid);
                var suffix;

                if (!width || !/^\d+$/.test(id) || Number(size.maxwidth) !== width || Number(size.maxheight) !== width) {
                    return;
                }
                suffix = 'resizeid=' + id + '&resizeh=' + width + '&resizew=' + width;
                if (size.urlsuffix === suffix && !presets[size.name]) {
                    presets[size.name] = '/site/images/Contact.jpg?' + suffix;
                }
            });
            if (names.some(function missingPreset(name) { return !presets[name]; })) {
                return html;
            }
            names.forEach(function candidate(name) {
                candidates.push(presets[name].replace(/&/g, '&amp;') + ' ' + wanted[name] + 'w');
            });

            return html.replace(/<img\b[^>]*>/gi, function contactImage(tag) {
                var source = tag.match(/\ssrc\s*=\s*(["'])([^"']+)\1/i);
                var width = tag.match(/\swidth\s*=\s*(["'])775\1/i);
                var attributes;

                if (!source || source[2] !== '/site/images/Contact.jpg' || !width || /\b(?:srcset|sizes)\s*=/i.test(tag)) {
                    return tag;
                }
                tag = tag.replace(source[0], ' src="' + presets.nmscard2x.replace(/&/g, '&amp;') + '"');
                attributes = ' srcset="' + candidates.join(', ') + '" sizes="(max-width: 806px) calc(100vw - 32px), 775px"';
                if (!/\bheight\s*=/i.test(tag)) {
                    attributes += ' height="581"';
                }
                // This known CMS photo starts in the Contact page's first viewport.
                // Its responsive sources are already qualified; do not defer its LCP request.
                var loading = tag.match(/\sloading\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/i);
                var priority = tag.match(/\sfetchpriority\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/i);
                if (loading) tag = tag.replace(loading[0], ' loading="eager"');
                else attributes += ' loading="eager"';
                if (priority) tag = tag.replace(priority[0], ' fetchpriority="high"');
                else attributes += ' fetchpriority="high"';
                if (!/\salt\s*=/i.test(tag)) {
                    attributes += ' alt="Nationwide Medical Surgical warehouse and delivery area"';
                }
                return tag.replace(/\s*\/?\s*>$/, function finish(end) { return attributes + end; });
            });
        }

        function installResponsiveContactImage() {
            var prototype = SCCCTHtmlView && SCCCTHtmlView.prototype;
            var originalGetContext;

            if (!prototype || typeof prototype.getContext !== 'function' || prototype.nmsResponsiveContactImage) {
                return;
            }
            originalGetContext = prototype.getContext;
            prototype.getContext = function contactImageContext() {
                var context = originalGetContext.apply(this, arguments);
                var settings = typeof SC !== 'undefined' && SC.ENVIRONMENT && SC.ENVIRONMENT.siteSettings;
                var html;
                var copy;
                var key;

                if (this.instanceId !== 'CMS_HTML-11' || !context || typeof context.htmlString !== 'string') {
                    return context;
                }
                html = responsiveContactHtml(context.htmlString, settings && settings.imagesizes);
                if (html === context.htmlString) {
                    return context;
                }
                copy = {};
                for (key in context) {
                    if (Object.prototype.hasOwnProperty.call(context, key)) {
                        copy[key] = context[key];
                    }
                }
                copy.htmlString = html;
                return copy;
            };
            prototype.nmsResponsiveContactImage = true;
        }

        function currentRoute() {
            var hash = window.location.hash.replace(/^#/, '').split('?')[0];
            var route = hash || window.location.pathname;

            return route.length > 1 ? route.replace(/\/$/, '') : route;
        }

        function normalize(value) {
            return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
        }

        function syncSandboxHomeTitle() {
            if (window.location.hostname === 'buyflu-sandbox.ethanablatt.com' && currentRoute() === '/') {
                document.title = 'Nationwide Medical Surgical';
            }
        }

        function restoreRequestAQuoteContent(content) {
            if (
                currentRoute() === '/request-a-quote' &&
                window.location.hostname === 'sca-sandbox.ethanablatt.com' &&
                !normalize(content.textContent)
            ) {
                content.innerHTML = nmsRequestAQuoteFallbackTpl({});
            }
        }

        function clearClasses() {
            Array.prototype.forEach.call(document.querySelectorAll('.' + contentClass), function removeContentClass(element) {
                element.classList.remove(contentClass);
            });
            Array.prototype.forEach.call(document.querySelectorAll('.' + breadcrumbClass), function removeBreadcrumbClass(element) {
                element.classList.remove(breadcrumbClass);
            });
            Array.prototype.forEach.call(document.querySelectorAll('.' + duplicateClass), function removeDuplicateClass(element) {
                element.classList.remove(duplicateClass);
            });
        }

        function sync() {
            var enabled = typeof window !== 'undefined' && !!supportedRoutes[currentRoute()];
            var content = enabled
                ? document.querySelector('[data-cms-area$="cms-landing-page-placeholder-page-type"]')
                : null;
            var breadcrumb = enabled ? document.querySelector('.global-views-breadcrumb') : null;
            var title;
            var titleText;

            syncSandboxHomeTitle();
            clearClasses();
            document.body.classList.toggle(pilotClass, enabled && !!content);

            if (!content) {
                return;
            }

            content.classList.add(contentClass);
            restoreRequestAQuoteContent(content);

            if (breadcrumb) {
                breadcrumb.classList.add(breadcrumbClass);
            }

            title = content.querySelector('h1');
            titleText = normalize(title && title.textContent);

            if (titleText) {
                Array.prototype.forEach.call(content.querySelectorAll('h2, h3, h4'), function markDuplicate(heading) {
                    if (normalize(heading.textContent) === titleText) {
                        heading.classList.add(duplicateClass);
                    }
                });
            }
        }

        return {
            responsiveContactHtml: responsiveContactHtml,
            installResponsiveContactImage: installResponsiveContactImage,
            mountToApp: function mountToApp(container) {
                var layout = container && container.getComponent
                    ? container.getComponent('Layout')
                    : null;

                installResponsiveContactImage();
                sync();

                if (layout) {
                    layout.on('afterShowContent', sync);
                }
            }
        };
    }
);
